module.exports = __webpack_public_path__ + "static/img/companyNews2.a75c0ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/joinus/companyNews2.png
// module id = I4BV
// module chunks = 18